import { render, staticRenderFns } from "./AcademyList.vue?vue&type=template&id=d26d6ebe&"
import script from "./AcademyList.vue?vue&type=script&lang=js&"
export * from "./AcademyList.vue?vue&type=script&lang=js&"
import style0 from "./AcademyList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports